import { PhotoData } from "../types/tournament";

export const reOrderPhotos = (
    photos: PhotoData[],
    destination?: PhotoData,
    source?: PhotoData,
) => {
    const prev = [...photos];
    const sourceIndex = prev.findIndex(p => p.photo === source?.photo);
    const destinationIndex = prev.findIndex(
        p => p.photo === destination?.photo,
    );

    if (source && destination) {
        const [movedPhoto] = prev.splice(sourceIndex, 1);
        prev.splice(destinationIndex, 0, movedPhoto);
    }

    return prev.map((photo, index) => ({
        ...photo,
        order: index + 1,
    }));
};
